import { useTranslation } from "react-i18next";

import { LICENSE_TAB_IDS } from "../../constants/LicenseManagement.constants";

import {
  AIRecommendationsIcon,
  PermeabilityIcon,
  SpecialElementsIcon,
} from "../../assets/icons";

export const ALL_LICENSED_FEATURES_CONFIG = [
  {
    key: LICENSE_TAB_IDS.USE_PERMEABILITY,
    titleKey: "licensedFeaturesDocumentation.usePermeabilityTitle",
    descriptionKey: "licensedFeaturesDocumentation.usePermeabilityDescription",
    icon: PermeabilityIcon,
  },
  {
    key: LICENSE_TAB_IDS.AI_RECOMMENDATIONS,
    titleKey: "licensedFeaturesDocumentation.aiRecommendationsTitle",
    descriptionKey:
      "licensedFeaturesDocumentation.aiRecommendationsDescription",
    icon: AIRecommendationsIcon,
  },
  {
    key: LICENSE_TAB_IDS.SPECIAL_RO_ELEMENTS,
    titleKey: "licensedFeaturesDocumentation.specialRoElementsTitle",
    descriptionKey:
      "licensedFeaturesDocumentation.specialRoElementsDescription",
    icon: SpecialElementsIcon,
  },
];

const IntroductionPage = ({
  userAssignedLicenseTabIds,
  userAccessibleLicenseTabIds,
  setSelectedLicenseTabId,
}) => {
  const { t } = useTranslation();

  return (
    <div className="introduction-page">
      <div className="introduction-page__title">
        {t("licensedFeaturesDocumentation.introTitle")}
      </div>
      <div className="introduction-page__description">
        {t("licensedFeaturesDocumentation.introDescription")}
      </div>

      <div className="licensed-features">
        {ALL_LICENSED_FEATURES_CONFIG.filter((feature) =>
          userAssignedLicenseTabIds.includes(feature.key),
        ).map((feature) => {
          const isAccessible = userAccessibleLicenseTabIds.includes(
            feature.key,
          );

          return (
            <button
              key={feature.key}
              className="licensed-feature"
              disabled={!isAccessible}
              onClick={() => setSelectedLicenseTabId(feature.key)}
            >
              <div className="licensed-feature__icon">
                <feature.icon width={50} height={50} />
              </div>
              <div className="licensed-feature__content">
                <div className="licensed-feature__title">
                  {t(feature.titleKey)}
                </div>
                <div className="licensed-feature__description">
                  {t(feature.descriptionKey)}
                </div>
              </div>
            </button>
          );
        })}
      </div>
      <div></div>
    </div>
  );
};

export default IntroductionPage;
